import React from 'react';
import { useFormContext } from '../AddSessionForm.types';
import { patientIsAvailableForDate } from '@uplift/api';


export const useSessionFormFieldsSync = () => {
  const formikContext = useFormContext();

  React.useEffect(() => {
    formikContext.setTouched({
      ...formikContext.touched,
      invitedPatient: undefined,
      existingPatient: undefined,
    });
    formikContext.setStatus(undefined);
  }, [ formikContext.values.isNewPatient ]);

  React.useEffect(() => {
    if (formikContext.values.existingPatient?.id && formikContext.values.startTime) {
      patientIsAvailableForDate({
        recurring: formikContext.values.repeats,
        datetime: formikContext.values.startTime,
        patient_id: formikContext.values.existingPatient?.id
      }).then(result => {
        if (result?.error) {
          formikContext.setStatus({ errorDisplayed: true, errorDescription: result.error, submissionBlocked: true });
        } else {
          formikContext.setStatus({ errorDisplayed: false, errorDescription: '', submissionBlocked: false });
        }
      });
    } else {
      formikContext.setStatus({ errorDisplayed: false, errorDescription: '', submissionBlocked: false });
    }
  }, [ formikContext.values.existingPatient, formikContext.values.startTime, formikContext.values.repeats ]); // eslint-disable-line react-hooks/exhaustive-deps

};
